var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("In order to authorize BudgetVals app to access Xero account data")]),_vm._v(" "),_c('button',{staticClass:"btn-success",attrs:{"type":"button"},on:{"click":function($event){return _vm.connectXero()}}},[_vm._v("\n    Connect to Xero Account\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bc0915e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/XeroSetting.vue
// module id = 1297
// module chunks = 1